import { DatePicker } from "react-rainbow-components";
const containerStyles = {
  maxWidth: 500,
};

export default function DatePickers({
  value,
  onChange,
  onBlur,
  error,
  touched,
  nombre,
  title,
  minDate,
}) {
  const handleChange = (e) => {
    onChange(nombre, e);
  };

  const handleBlur = () => {
    onBlur(nombre, true);
  };
  return (
    <div className="col-md-4">
      <label>
        {title}
        <span className="text-red-500">*</span>:
      </label>
      <div
        className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto"
        style={containerStyles}
      >
        <DatePicker
          locale="es-ES"
          id={nombre}
          onChange={handleChange}
          onBlur={handleBlur}
          value={value}
          minDate={minDate}
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          }
        />
      </div>
      {!!error && touched && (
        <div style={{ color: "red", marginTop: ".5rem" }}>{error}</div>
      )}
    </div>
  );
}
